import { useDispatch, useSelector } from "react-redux";
import { downloadTradesReport } from "../thunks/downloadReport";
import React from "react";
import { StoreType } from "../../../../core/store/reducers";
import { FetchStateType } from "../../../models";

export const useTradeBookReportDownloader = () => {
	const fetchState = useSelector<StoreType, FetchStateType>(
		s => s.data.domestic.trades.printTradeFetchState
	);
	const dispatch = useDispatch();
	const download = React.useCallback(() => dispatch(downloadTradesReport()), [dispatch]);

	return [download, fetchState] as [typeof download, typeof fetchState]
};
